"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HCaptchaLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class HCaptchaLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor() {
        super('HCaptcha', constants_1.LOAD_CONFIG);
    }
    getUrls() {
        return [constants_1.URL];
    }
}
exports.HCaptchaLoader = HCaptchaLoader;
//# sourceMappingURL=index.js.map